module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h4', {
    staticClass: "headline ma-0 grey--text text--darken-2"
  }, [_vm._v("Profilübersicht")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('span', [_vm._v("Name: " + _vm._s(_vm.user.forename) + " " + _vm._s(_vm.user.name))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('span', [_vm._v("Letzter Login: " + _vm._s(_vm.user.lastlogin_at))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('span', [_vm._v("Letzte Aktivität:")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-991fdc28","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/profilCard.vue
// module id = 336
// module chunks = 0